import { call, put, takeEvery } from "redux-saga/effects";

// Calender Redux States
import {
    CREATE_BRANCH,
    DELETE_BRANCH,
    GET_BRANCH_LISTING,
    UPDATE_BRANCH
} from "./actionTypes.js";

import {
    createBranchFail,
    createBranchSuccess,
    deleteBranchFail,
    deleteBranchSuccess,
    getBranchListingFail,
    getBranchListingSuccess,
    updateBranchFail,
    updateBranchSuccess
} from "./actions.js";

import { branchCreateApi, branchDeleteApi, branchListingApi, branchUpdateApi } from "./branchApi.js";

function* fetchBranchListing({ payload }) {
    try {
        const response = yield call(branchListingApi, payload);
        yield put(getBranchListingSuccess(response));
    } catch (error) {
        yield put(getBranchListingFail(error));
    }
}

function* fetchBranchCreate({ payload }) {
    try {
        const response = yield call(branchCreateApi, payload);
        yield put(createBranchSuccess(response));
    } catch (error) {
        yield put(createBranchFail(error));
    }
}

function* fetchBranchUpdate({ payload }) {
    try {
        const response = yield call(branchUpdateApi, payload);
        yield put(updateBranchSuccess(response));
    } catch (error) {
        yield put(updateBranchFail(error));
    }
}

function* fetchBranchDelete({ payload }) {
    try {
        const response = yield call(branchDeleteApi, payload);
        yield put(deleteBranchSuccess(response));
    } catch (error) {
        yield put(deleteBranchFail(error));
    }
}


function* BranchSaga() {
    yield takeEvery(GET_BRANCH_LISTING, fetchBranchListing);
    yield takeEvery(CREATE_BRANCH, fetchBranchCreate);
    yield takeEvery(UPDATE_BRANCH, fetchBranchUpdate);
    yield takeEvery(DELETE_BRANCH, fetchBranchDelete);
}

export default BranchSaga